import { Stack, IconButton } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PercentIcon from '@mui/icons-material/Percent';
import DeltaIcon from '../../../icons/DeltaIcon';
import { StrikeDisplayType } from '../../../types';

const TYPE_TO_ICON = new Map<StrikeDisplayType, React.ReactNode>([
  [StrikeDisplayType.FixedStrike, <AttachMoneyIcon />],
  [StrikeDisplayType.Delta, <DeltaIcon />],
  [StrikeDisplayType.Moneyness, <PercentIcon />],
]);

interface VolSkewTypeSwitchProps {
  value: StrikeDisplayType;
  onChange: (type: StrikeDisplayType) => void;
}

export const VolSkewTypeSwitch = ({
  value,
  onChange,
}: VolSkewTypeSwitchProps) => {
  return (
    <Stack direction="row">
      {[...TYPE_TO_ICON.entries()].map(([dispType, icon], index: number) => (
        <IconButton
          key={`${dispType}-${index}`}
          onClick={(_evt) => {
            onChange(dispType);
          }}
          size="small"
          color="primary"
          disabled={value === dispType}
        >
          {icon}
        </IconButton>
      ))}
    </Stack>
  );
};
